export type CertificatedUser = {
  firstName: string;
  lastName: string;
};

export type Certificate = {
  user: CertificatedUser;
  valid?: boolean;
  authority?: string;
  submittedOn?: string;
};

export enum ErrorTypes {
  cert = "Certificate error",
  qrcode = "QR Code error",
  server = "Server error",
};
